import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import WeatherWidget from './WeatherWidget';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [currentDate, setCurrentDate] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const updateDate = () => {
      const now = new Date();
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      };
      setCurrentDate(now.toLocaleDateString('en-US', options));
    };

    updateDate();
    const interval = setInterval(updateDate, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 90; // Account for navbar height
      const elementPosition = element.offsetTop - navbarHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  if (isHomePage) {
    // For home page, simplified layout with just date, weather, and nav
    return (
      <nav className={`navbar home-navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container home-page">
          <div className="navbar-date home-date">{currentDate}</div>
          
          <div className="weather-widget-wrapper">
            <WeatherWidget />
          </div>
          
          <ul className="nav-menu">
            <li className="nav-item">
              <button onClick={() => scrollToSection('home')} className="nav-links">Home</button>
            </li>
            <li className="nav-item">
              <button onClick={() => scrollToSection('about')} className="nav-links">About</button>
            </li>
            <li className="nav-item">
              <button onClick={() => scrollToSection('projects')} className="nav-links">Projects</button>
            </li>
            <li className="nav-item">
              <button onClick={() => scrollToSection('contact')} className="nav-links">Contact</button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }

  // For other pages, use the original structure but with modern styling
  return (
    <nav className="navbar">
      <div className="navbar-container non-home-page">
        <div className="navbar-logo">Evan Jelle</div>
        <div className="navbar-date">{currentDate}</div>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-links">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/resume" className="nav-links">Resume</Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-links">Blog</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-links">Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
